import React from "react";
import { Box, Typography, IconButton, Divider } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { ServiceSummary } from "shared/types";

interface ServicesCardProps {
  services: ServiceSummary[];
  isOwnProfile?: boolean;
}

const ServicesCard: React.FC<ServicesCardProps> = ({
  services,
  isOwnProfile = false,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: 2,
        p: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        mb: 3,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          Services
        </Typography>
        {isOwnProfile && (
          <IconButton size="small">
            <EditIcon fontSize="small" />
          </IconButton>
        )}
      </Box>

      {/* Services List */}
      <Box>
        {services.map((service, index) => (
          <Box key={index}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                py: 2,
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, mb: 0.5, color: "#333" }}
                >
                  {service.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#5A5A5A", fontSize: "0.875rem" }}
                >
                  {service.description}
                </Typography>
              </Box>

              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: "#178B8E",
                  ml: 2,
                  whiteSpace: "nowrap",
                }}
              >
                ${service.price}
                <Typography
                  component="span"
                  sx={{ fontSize: "0.875rem", fontWeight: 400 }}
                >
                  /{service.unit}
                </Typography>
              </Typography>
            </Box>

            {index < services.length - 1 && <Divider />}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ServicesCard;
